import { FormControl, Slider, SliderOwnProps, Typography } from '@mui/material';
import { FC } from 'react';
import { useController } from 'react-hook-form';

export interface SliderInputProps extends SliderOwnProps {
  label?: string;
  source: string;
  controlClassName?: string;
}

export const SliderInput: FC<SliderInputProps> = ({
  defaultValue,
  label,
  controlClassName,
  source,
  ...rest
}) => {
  const input = useController({ name: source, defaultValue });
  return (
    <FormControl className={controlClassName}>
      {!!label && <Typography gutterBottom>{label}</Typography>}
      <Slider {...input.field} {...rest} />
    </FormControl>
  );
};
